var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoSquareFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54167 0.125H11.4583C12.2375 0.125 12.875 0.755417 12.875 1.54167V11.4583C12.875 11.8337 12.7262 12.195 12.4571 12.4571C12.195 12.7262 11.8337 12.875 11.4583 12.875H1.54167C1.16625 12.875 0.805 12.7262 0.542917 12.4571C0.27375 12.195 0.125 11.8337 0.125 11.4583V1.54167C0.125 0.755417 0.755417 0.125 1.54167 0.125ZM7.20833 4.375V2.95833H5.79167V4.375H7.20833ZM7.20833 10.0417V5.79167H5.79167V10.0417H7.20833Z",
    fill: "#0D6EFD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquareFill);
export default __webpack_public_path__ + "static/media/InfoSquareFill.9eed70d0.svg";
export { ForwardRef as ReactComponent };